import styled from '@emotion/styled';

export const StyledConnector = styled.span`
  display: block;
  border-color: rgb(189, 189, 189);
  border-top-style: solid;
  border-top-width: 1px;
`;

export const StyledStep = styled.div`
  display: flex;
  color: rgba(0, 0, 0, ${({ isDisabled }) => (isDisabled ? '0.26' : '0.87')});
  cursor: pointer;
  height: 72px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  padding-left: 14px;
  padding-right: 14px;
`;

const svgColorFill = isDisabled => (isDisabled ? 'rgb(158, 158, 158)' : 'rgb(33, 33, 33)');

export const StyledSVG = styled.svg`
  color: ${({ isDisabled }) => svgColorFill(isDisabled)};
  display: block;
  fill: ${({ isDisabled }) => svgColorFill(isDisabled)};
  font-size: 24px;
  height: 24px;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  user-select: none;
  width: 24px;
`;
